import styled from 'styled-components';

export const ResourcesFilterBarShortcutsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  padding: 20px 0px;

  border-radius: 16px;
`;

export const ResourcesFilterBarShortcutsTitle = styled.h4`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

//ITEM
export const ResourcesFilterBarShortcutsItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  padding: 10px;

  border-radius: 20px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 6px 24px 0 rgba(0, 0, 0, 0.1);

  cursor: pointer;
`;

export const ResourcesFilterBarShortcutsItemLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: var(--color-text);
`;
